import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { type ClientPackageAppendixDocumentDto, createAppendixDocument } from '../../generated/client';

export const useAddAppendixDocument = (): UseMutationResult<ClientPackageAppendixDocumentDto, AxiosError, { documentId: number; file: File }> => {
    const { t } = useTranslation();

    return useMutation({
        mutationFn: ({ documentId, file }) => createAppendixDocument({ path: { documentId }, body: { pdfFile: file } }).then((result) => result.data!),
        onSuccess: () => showSuccessToast(t('clientPackageAppendixDocumentUploadSuccess')),
        onError: (error) => showErrorToast({ error, userMessage: t('clientPackageAppendixDocumentUploadFailure') }),
    });
};
